import { render, staticRenderFns } from "./manageorganizers.html?vue&type=template&id=79dd63ca&scoped=true&"
import script from "./manageorganizers.js?vue&type=script&lang=js&"
export * from "./manageorganizers.js?vue&type=script&lang=js&"
import style0 from "./manageorganizers.scss?vue&type=style&index=0&id=79dd63ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dd63ca",
  null
  
)

export default component.exports